document.addEventListener('DOMContentLoaded', function () {
  var menuIconSp = document.getElementById('menu_icon_sp');
  var spMenu = document.querySelector('.sp_menu');
  var body = document.querySelector('body');

  if (menuIconSp && spMenu) {
    menuIconSp.addEventListener('change', function () {
      spMenu.classList.toggle('is_active', menuIconSp.checked);
      body.classList.toggle('no_scroll', menuIconSp.checked);
    });
  }
});
